import axios from 'axios'; // 导入http中创建的axios实例
import base from './base'; // 导入接口域名列表

const key = {
  // post提交
  getKeys() {
    return axios.get(`/app/key`);
  }
}

export default key;
